/* import __COLOCATED_TEMPLATE__ from './fixed-string-variable-configs.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();